var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"alert",attrs:{"transition":"scroll-x-reverse-transition","type":_vm.type,"border":"left","elevation":"3"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }